import { Alert, Box, Button, Flex } from "@mantine/core";
import { IMeeting } from "@mctypes/meeting.types";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useHistory } from "react-router";
import { AG_GRID_LOCALE_NOR } from "../../../../agGridLocale";
import { DisplayDueDate, FailedAlert } from "../../../../components";
import { useAppSelector } from "../../../../hooks";
import { useGetMeetingParticipantByUserIdQuery } from "../../../../../openapi";
import { isValidDateValue } from "../../admin/selectors";
import { ISSUE_COMPLETED_VALUE, ISSUE_EXPIRED } from "../../issuesApp/issueConstants";

const UserParticipantInMeeting: React.FC<{}> = () => {
  const user = useAppSelector((state) => state.globalReducer.user);

  const { data: meetingsForUser = [], isError } = useGetMeetingParticipantByUserIdQuery({
    userId: user._id,
  });

  const history = useHistory();

  const goToMeeting = async (meeting: IMeeting.Meeting) => {
    if (meeting != null) {
      history.push(`/project/${meeting.project}/meetings/${meeting._id}`);
    }
  };

  return (
    <>
      {isError === true && <FailedAlert errorMessage="Kunne ikke laste inn dine møter" />}
      {isError === false && meetingsForUser.length === 0 && (
        <Box flex={1} px="0.25rem" style={{ overflow: "auto" }}>
          <Alert color="green" variant="light" mt="xl">
            <i className="fa fa-check fa-fw" />
            Du har ingen kommende møter.
          </Alert>
        </Box>
      )}
      {isError === false && meetingsForUser.length > 0 && (
        <>
          <Box className="ag-theme-quartz" h="100%" w="100%">
            <AgGridReact
              rowData={meetingsForUser}
              columnDefs={createActiveMeetingsColumns(goToMeeting)}
              domLayout={"autoHeight"}
              rowSelection={{ mode: "singleRow", checkboxes: false }}
              animateRows={true}
              suppressContextMenu={true}
              localeText={AG_GRID_LOCALE_NOR}
              defaultColDef={{ suppressHeaderMenuButton: true }}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default UserParticipantInMeeting;

const createActiveMeetingsColumns = (goToMeeting: (item: IMeeting.Meeting) => void) => {
  const columns: ColDef<any>[] = [
    {
      field: "name",
      headerName: "Møte",
      cellRenderer: (params) => {
        return (
          <>
            <Flex style={{ alignItems: "center" }}>
              <Button m={0} p={0} onClick={() => goToMeeting(params.data)} variant="subtle">
                {params.value}
              </Button>
            </Flex>
          </>
        );
      },
      filter: "agTextColumnFilter",
      flex: 1,
    },
    {
      field: "meetingSerie.name",
      headerName: "Møteserie",
      filter: "agTextColumnFilter",
      flex: 1,
    },
    {
      field: "dateOfMeeting",
      headerName: "Dato",
      cellRenderer: (params) => {
        if (isValidDateValue(params.value) === false) {
          return "-";
        }
        return (
          <DisplayDueDate
            dueDate={params.value}
            isComplete={params.data.status === ISSUE_COMPLETED_VALUE || params.data.status === ISSUE_EXPIRED}
          />
        );
      },
      filter: "agDateColumnFilter",
    },
  ];
  return columns;
};
